import request from '../request'
// ====aon 答谢抽奖活动start===
// 获取抽奖结果
const aonQueryAwardRes = data => {
  return request.get(`/midesk/invitationLetter/queryByOpenId/${data.openId}`)
}
// 注册用户
const aonRegist = data => {
  return request.post('/midesk/invitationLetter/save', data)
}
// 抽奖
const aonLucky = data => {
  return request.post(`/midesk/invitationLetter/luckyDraw/${data.level}`)
}
// 查询中奖数据
const aonGetLuckys = data => {
  return request.get(`/midesk/invitationLetter/queryLuckyDraw/${data.level}`)
}
// 清空抽奖数据
const cleanLuckys = data => {
  return request.get('/midesk/invitationLetter/clean')
}
// ====aon 答谢抽奖活动end===

export default {
  aonQueryAwardRes,
  aonRegist,
  aonLucky,
  aonGetLuckys,
  cleanLuckys
}
